import './index.scss'
$(function() {
    $(".pro-common-honor .tabitem .un-ul li").click(function() {
        console.log('111122');
        $(this).addClass('active').siblings().removeClass('active')
        $('.pro-common-honor .tabitem .tab-body>div').eq($(this).index()).show().siblings().hide();
        $('.itemmap').eq($(this).index()).show().siblings('.itemmap').hide();
    });
});